import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useGetAssetType } from 'Libs/utils';
import React from 'react';
import { CardHeader } from './atoms/SmallComponents';
import { CurrencyFormat } from './CurrencyFormat';
import CustomSegmentedTab from './CustomSegmentedTab';
import { changeObjKey } from './DataCustomizer';
import { formatDate } from './DateFormatter';

const PerformanceChartCompare = ({ chartData = [], type = 1, fundNames = [], isin_code = [], fundColors = [], xAxisKey = "Date" }) => {
    const yrtabs = [
        { key: "A", label: "1Y", value: "365D", show: chartData["365D"]?.data?.length > 0 },
        { key: "b", label: "3Y", value: "1095D", show: chartData["1095D"]?.data?.length !== chartData["365D"]?.data?.length },
        { key: "c", label: "5Y", value: "1825D", show: chartData["1825D"]?.data?.length !== chartData["1095D"]?.data?.length },
        { key: "d", label: "10Y", value: "3650D", show: chartData["3650D"]?.data?.length !== chartData["1825D"]?.data?.length },
        { key: "dm", label: "Max", value: "max", show: chartData["max"]?.data?.length !== chartData["3650D"]?.data?.length },
    ]
    const screen_type = useGetAssetType()
    const chipset = [
        { "key": "a", "name": "₹ 5,000", value: 5000 },
        { "key": "b", "name": "₹ 10,000", value: 10000 },
        { "key": "c", "name": "₹ 50,000", value: 50000 },
    ]

    const [noChart, setnoChart] = React.useState(false);
    const [chartType, setChartType] = React.useState(yrtabs[0].value)
    const [chartAmount, setChartAmount] = React.useState(chipset[1])

    try {
        var options = {
            chart: {
                backgroundColor: "transparent",
                height: 250,
            },
            title: {
                text: ''
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                visible: false,
                tickAmount: 5,
                gridLineDashStyle: 'longdash',
                title: {
                    text: ''
                },
                gridLineColor: 'var(--border)',
            },
            xAxis: [{
                type: 'datetime',
                dateTimeLabelFormats: {
                    millisecond: '%H:%M:%S.%L',
                    second: '%H:%M:%S',
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%eth %b',
                    week: '%eth %b',
                    month: '%b \'%y',
                    year: '%Y'
                },
                lineColor: 'var(--border)',
                tickColor: 'var(--border)',
            }
            ],
            legend: {
                enabled: false,
                //     useHTML: true,
                //     symbolWidth: 5,
                //     symbolRadius: 6,
                //     itemWidth: 148,
                //     itemStyle: {
                //         color: 'var(--border)',
                //         fontSize: 10,
                //         fontWeight: "normal",
                //         overflow: "visible",
                //         marginTop: 5

                //     },
                //     labelFormatter: function () {
                //         return '<div style="margin-bottom:2px">' + this.name.replace(/(.*?\s.*?\s.*?\s)/g, '$1' + '<br>') + '</div>';
                //     },
            },
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    marker: {
                        enabled: false
                    }
                }
            },
            tooltip: {
                shared: true,
                valueDecimals: 0,
                valuePrefix: '₹',
            },
            credits: {
                enabled: false
            },
            boost: {
                useGPUTranslations: true,
            },
            series:
                isin_code.map((i, index) => {
                    return {
                        name: type !== 4 ? fundNames[index][`fund_${i}`] : fundNames[index][`${i}`],
                        turboThreshold: 9e9,
                        // color: t.colors.secondary,
                        // tooltip: {
                        //     valueSuffix: ` ({point.ret_fund_${i}}%)`,
                        // },
                        marker: { symbol: 'square', radius: 1 },
                        color: fundColors[index],
                        data: changeObjKey(chartData[chartType], [type !== 4 ? `fund_${i}` : i, xAxisKey], ["y", "x"], "mfetfChart", (chartAmount.value / 10000))
                    }
                })
            ,
            scrollbar: {
                enabled: false
            },
            // responsive: {
            //     rules: [{
            //         condition: {
            //             maxWidth: 400
            //         },
            //     }]
            // },

        };
    } catch (error) {
        console.log("SDF", error)
        setnoChart(true)
    }


    // const options = {
    //     global: {
    //         useUTC: true
    //     },
    //     lang: {
    //         decimalPoint: '.',
    //         thousandsSep: ','
    //     }
    // };


    const ContentBeforeChart = () => {

        try {
            if (chartType) {
                var mintData = JSON.parse(chartData?.[chartType]?.data)
            }
            return <div style={{ flex: 1, display: "flex", flexDirection: "row", alignItems: "center" }}>
                <div className='fontH2' style={{ flex: 1, color: 'var(--black)', display: "flex", alignItems: "center", gap: "0.3rem" }}>
                    <CardHeader heading={'Performance comparision'} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'right', borderTop: "1px solid var(--grey3)", borderBottom: "1px solid var(--grey3)", padding: "0.4rem" }} >
                    <CustomSegmentedTab
                        isBlock={false}
                        className='performanceChartYrSegmented'
                        style={{ backgroundColor: "transparent", padding: 0 }}
                        options={yrtabs}
                        value={chartType}
                        onChange={(e) => setChartType(e)}
                    />
                </div>
            </div>
        } catch (error) {
            return <></>
        }
    };




    try {
        return (
            noChart ? <div className='bodyTextDark' style={{ margin: "4rem", textAlign: "center" }}>
                No chart data available!
            </div>
                : <div>
                    <ContentBeforeChart />
                    <div>
                        <HighchartsReact highcharts={Highcharts} options={options} />
                        {/* {
                            <div className='textXS' style={{ padding: "4px", textAlign: 'justify' }}>
                                <b>Note: </b>Past performance is not an assurance of future performance. The chart has been shown based on EOD {screen_type.value === 4 ? "prices" : "NAVs"} of the {screen_type.dname}.
                            </div>
                        } */}
                    </div>
                </div>
        );
    } catch (error) {
        console.log(error)
        return <div className='bodyTextDark' style={{ margin: "4%", textAlign: "center" }}>
            No chart data available!
        </div>
    }
};
export default PerformanceChartCompare;